export default __webpack_public_path__ + "static/media/qris3.a95d952b.png";